/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import StudentRouteLinkItem from './StudentRouteLinkItem';
import CalendarIcon from 'icons/CalendarIcon';

const messages = defineMessages({
  title: {id: 'navigation.calendar'},
});

const CalendarItem = () => (
  <StudentRouteLinkItem
    iconBefore={CalendarIcon}
    route="midas/student/calendar"
    title={messages.title}
  />
);

export default CalendarItem;
